module.exports = __webpack_public_path__ + "static/media/guitar.d214a750.svg";